export default __webpack_public_path__ + "static/media/lupa.fd7213b8.svg";